import React from 'react';




const MySkills = () => {
    return (
        <div className='mx-12 py-16'>
        
            <h1 className='text-3xl text-center font-bold my-4'>MY SKILLS</h1>
      
            <div className='grid sm:grid-cols-1 lg:grid-cols-4 gap-8'>
              

                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://freeiconshop.com/wp-content/uploads/edd/html-flat.png" alt="" />
                <h1 className=' text-xl text-center'>HTML</h1>
                </div>

                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://www.pngkey.com/png/full/624-6241203_css-icon-png-cascading-style-sheets.png" alt="" />
                <h1 className=' text-xl text-center'>CSS</h1>
                </div>


                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://i.ibb.co/w6D8cLv/bootstrap.png" alt="" />
                <h1 className=' text-xl text-center'>Bootstrap-5</h1>
                </div>


                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://i.ibb.co/kJky7s4/tailwind.png" alt="" />
                <h1 className=' text-xl text-center'>Tailwind css</h1>
                </div>


                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://i.ibb.co/vdjQcx6/jsc.png" alt="" />
                <h1 className=' text-xl text-center'>JavaScript</h1>
                </div>


                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://i.ibb.co/VB9vRCZ/react.png" alt="" />
                <h1 className=' text-xl text-center'>React</h1>
                </div>


                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://i.ibb.co/RcMYXGv/nodeExp.png" alt="" />
                <h1 className=' text-xl text-center'>Express Js</h1>
                </div>


                <div className='bg-[#090222] hover:bg-[#110833] p-3 rounded-xl'>
                <img className='mx-auto my-4' width="60px" src="https://i.ibb.co/tm4yg7x/mong.png" alt="" />
                <h1 className=' text-xl text-center'>MongoDB</h1>
                </div>

           </div>



        </div>
    );
};

export default MySkills;